var map = {
	"./iso-13485.webp": 1830,
	"./iso-14001.webp": 1831,
	"./iso-27001.webp": 1832,
	"./iso-45001.webp": 1833,
	"./iso-9001.webp": 1834,
	"./siq-m-222.webp": 1835
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1829;